import { useRef, useState, type ButtonHTMLAttributes, type MouseEvent } from "react";

type Ripple = {
  id: number;
  x: number;
  y: number;
  size: number;
};

type SidebarNavButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

export function SidebarNavButton({ className = "", onClick, children, ...props }: SidebarNavButtonProps) {
  const [ripples, setRipples] = useState<Ripple[]>([]);
  const rippleIdRef = useRef(0);

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const size = Math.max(rect.width, rect.height) * 2.5;
    const id = ++rippleIdRef.current;

    setRipples((prev) => [...prev, { id, x, y, size }]);
    window.setTimeout(() => {
      setRipples((prev) => prev.filter((ripple) => ripple.id !== id));
    }, 600);

    onClick?.(e);
  };

  return (
    <button
      type="button"
      {...props}
      className={`erp-sidebar-item relative shrink-0 overflow-hidden ${className}`}
      onClick={handleClick}
    >
      {ripples.map((ripple) => (
        <span
          key={ripple.id}
          aria-hidden
          className="sidebar-nav-ripple pointer-events-none absolute rounded-full bg-client-primary"
          style={{
            left: ripple.x,
            top: ripple.y,
            width: ripple.size,
            height: ripple.size,
          }}
        />
      ))}
      <span className="relative z-[1] contents">{children}</span>
    </button>
  );
}
